import React from 'react'
import { Container, Text } from './styles/footer'

export default function Footer({ children, ...restProps }) {
    return (
        <Container {...restProps}>{children}</Container>
    )
}

Footer.Text = function FooterText({children, ...restProps}){
    return <Text {...restProps}>{children}</Text>
}